<div  (resized)="onResized($event)">
	<div class="absolute right-0 p-3">
		v{{api.version}}
	</div>
	<router-outlet></router-outlet>
</div>
